module.exports = __webpack_public_path__ + "static/media/doc1.f2a7a28d.svg";